<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">Impressum</h1>
      <span class="is-size-7">
        <p>
          778 mobile GmbH <br>
          Wiesenstraße 21a2 <br>
          DE-40549 Düsseldorf - Germany <br>
          HRB 79227 <br>
          USt-IdNr: DE303966009 <br>
          Tukilinjan numero: <a class="has-text-primary" href="tel:00358942451583">+358 942451583</a> <br>
          Palvelulinjan posti: <a class="has-text-primary" href="mailto:keepyoufit.fi@silverlines.info">keepyoufit.fi@silverlines.info</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/FI/Imprint.vue